import React from "react";

export default function LoadingScreen({
  message = "กำลังเตรียมเกม... โปรดรอสักครู่",
}) {
  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center p-4 font-sans">
      {/* ตรวจสอบว่ามีไฟล์ loading.gif ในโฟลเดอร์ public ไหม ถ้าไม่มีให้ลบ img tag นี้ออกหรือเปลี่ยนรูป */}
      <img
        src="/loading.gif"
        alt="Loading..."
        className="w-48 h-48 mx-auto mb-8 object-contain"
        onError={(e) => {
          e.target.style.display = "none";
        }} // ซ่อนถ้ารูปเสีย
      />
      <p className="text-xl text-yellow-400 animate-pulse">{message}</p>
    </div>
  );
}
